import { render, staticRenderFns } from "./CommentsView.vue?vue&type=template&id=e57ea290"
import script from "./CommentsView.vue?vue&type=script&lang=ts"
export * from "./CommentsView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports